


import { Routes, RouterModule } from '@angular/router';
import { LogSubscribeComponent } from './logsubscribe.component';

const routes: Routes = [
    {
        path: '',
        component: LogSubscribeComponent
    },
];

export const LogSubscribeRoutes = RouterModule.forChild(routes);
